"use client";

import { c as _c } from "react/compiler-runtime";
import { BasketIcon } from "@local/ui/src/components/ui/icons";
import { cn } from "@local/utils/src/cn";
import { useState } from "react";
import { getT } from "@local/i18n/src/t";
import { getLanguageForMarket } from "@local/i18n/src/languages";
import { cart as cartCatalog } from "@local/i18n/src/catalogs/cart";
import { chrome as chromeCatalog } from "@local/i18n/src/catalogs/chrome";
interface CartButtonProps {
  onClick?: () => void;
  className?: string;
  iconClassName?: string;
  ariaLabel?: string;
  count?: number;
  showCount?: boolean;
  /** Public market slug — drives the aria/live-region language. */
  market?: string;
  /**
   * True once the client-side cart count has hydrated. When false, the diff
   * announcer treats every incoming `count` as the baseline and stays silent.
   * Parents that render a placeholder count during SSR (e.g.
   * TopNavigationBarClient passes `0` until `hasMounted`) must pass this so
   * the jump from placeholder to real count is not mistaken for an addition.
   * Defaults to `true` for callers with no hydration placeholder.
   */
  ready?: boolean;
}
export const CartButton = t0 => {
  const $ = _c(20);
  const {
    onClick,
    className,
    iconClassName,
    ariaLabel,
    count: t1,
    showCount: t2,
    ready: t3,
    market
  } = t0;
  const count = t1 === undefined ? 0 : t1;
  const showCount = t2 === undefined ? true : t2;
  const ready = t3 === undefined ? true : t3;
  const t = getT(getLanguageForMarket(market), {
    cart: cartCatalog,
    chrome: chromeCatalog
  });
  const label = ariaLabel ?? t("chrome.shoppingCart");
  const itemLabel = count === 0 ? t("cart.empty") : t("cart.itemCount", {
    count
  });
  const [lastCount, setLastCount] = useState(null);
  const [announcement, setAnnouncement] = useState("");
  if (ready && lastCount !== count) {
    setLastCount(count);
    if (lastCount !== null) {
      const totalLabel = t("cart.itemCountTotal", {
        count
      });
      setAnnouncement(count > lastCount ? t("cart.addedToCartAnnouncement", {
        total: totalLabel
      }) : t("cart.removedFromCartAnnouncement", {
        total: totalLabel
      }));
    }
  }
  let t4;
  if ($[0] !== className) {
    t4 = cn("relative flex aspect-square h-full cursor-pointer flex-row items-center justify-center sm:mr-1 sm:gap-3 md:mr-4", className);
    $[0] = className;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  const t5 = `${label}, ${itemLabel}`;
  const t6 = showCount && count > 0 && "md:border-r md:border-r-white md:pr-3 md:pl-1";
  let t7;
  if ($[2] !== iconClassName || $[3] !== t6) {
    t7 = cn("sm:static md:text-sm", t6, iconClassName);
    $[2] = iconClassName;
    $[3] = t6;
    $[4] = t7;
  } else {
    t7 = $[4];
  }
  let t8;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <BasketIcon />;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t9;
  if ($[6] !== t7) {
    t9 = <div className={t7}>{t8}</div>;
    $[6] = t7;
    $[7] = t9;
  } else {
    t9 = $[7];
  }
  let t10;
  if ($[8] !== count || $[9] !== showCount) {
    t10 = showCount && count > 0 && <span aria-hidden="true" className="absolute -top-2 -right-2 flex h-5 w-5 items-center justify-center rounded-full bg-red-400 text-sm md:static md:top-auto md:right-auto md:h-auto md:w-auto md:rounded-none md:bg-transparent">{count}</span>;
    $[8] = count;
    $[9] = showCount;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== announcement) {
    t11 = <span role="status" aria-live="polite" aria-atomic="true" className="sr-only">{announcement}</span>;
    $[11] = announcement;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== onClick || $[14] !== t10 || $[15] !== t11 || $[16] !== t4 || $[17] !== t5 || $[18] !== t9) {
    t12 = <button type="button" className={t4} aria-label={t5} onClick={onClick}>{t9}{t10}{t11}</button>;
    $[13] = onClick;
    $[14] = t10;
    $[15] = t11;
    $[16] = t4;
    $[17] = t5;
    $[18] = t9;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};